import React from 'react';
import { useI18n } from '../i18n';

const CreditDisplay = ({ credits, onClick }) => {
  const { t } = useI18n();
  // credits is null until /api/credits answers - a placeholder, not an alarming red zero.
  const loaded = typeof credits === 'number';

  const getDisplayClass = () => {
    if (!loaded) return 'credit-display pending';
    if (credits === 0) return 'credit-display empty';
    if (credits <= 1) return 'credit-display low';
    return 'credit-display';
  };

  return (
    <button
      className={getDisplayClass()}
      onClick={onClick}
      aria-busy={!loaded}
      title={loaded ? t('credits.tooltipBuy') : t('credits.tooltipLoading')}
      style={{
        border: 'none',
        cursor: 'pointer',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-1px)';
        e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = 'none';
      }}
    >
      {loaded ? `${t('credits.label', { count: credits })} ⚡` : `${t('credits.loading')} ⚡`}
    </button>
  );
};

export default CreditDisplay;
